// The values every audited enum column can hold, in Albanian. Keyed "Entity.Column": a column stored
// as an enum arrives as the member's name, one stored as a number arrives as the number. A column
// missing here shows the raw name, which reads as English code to whoever opens the page.
// This half covers the timetable and the catalogue; enumLabels.ts covers reservations and money.
const BUS_OR_TRAIN: Record<string, string> = { Bus: "Autobus", Train: "Tren" };
const PERCENT_OR_FIXED: Record<string, string> = { Percentage: "Përqindje", FixedValue: "Vlerë fikse" };
const RUNS_OR_NOT: Record<string, string> = {
  ExceptionDate: "Nuk qarkullon",
  SelectedWorkingDate: "Qarkullon"
};
const JOURNEY_TYPES: Record<string, string> = {
  Onward: "Vajtje",
  Return: "Kthim",
  TwoWay: "Vajtje-ardhje"
};

export const CATALOGUE_ENUM_LABELS: Record<string, Record<string | number, string>> = {
  "CustomTripWorkingDay.Type": RUNS_OR_NOT,
  "CustomTripWorkingDayPattern.Type": RUNS_OR_NOT,
  "Line.LineType": BUS_OR_TRAIN,
  "Station.StationType": BUS_OR_TRAIN,
  "Bus.Type": { Bus: "Autobus", Minibus: "Minibus" },
  "BusSeat.Status": { Disabled: "Joaktive", Enabled: "Aktive" },
  "FlexiRideType.CostType": PERCENT_OR_FIXED,
  "GTFSBlockedEntity.EntityType": { Operator: "Operator", Line: "Linjë", Trip: "Orar" },
  "FrequentlyAskedQuestion.QuestionFor": {
    City: "Qyteti",
    LinePage: "Faqja e linjës",
    Operator: "Operatori",
    LocationZone: "Zona",
    CityPage: "Faqja e qytetit"
  },
  "JourneyTicketMapping.JourneyType": JOURNEY_TYPES,
  "JourneyTripMapping.JourneyType": JOURNEY_TYPES,
  "InvitedUser.Status": { Pending: "Në pritje", Accepted: "Pranuar", Expired: "Skaduar" },
  "Review.ReviewType": { Journey: "Udhëtim", Esim: "eSIM" },
  "ImprovementPossibility.ReviewType": { Journey: "Udhëtim", Esim: "eSIM" },
  "UserFeedback.Status": { New: "I ri", Reviewed: "Shqyrtuar", Actioned: "Adresuar" },
  "UserFeedback.Source": {
    ReportLine: "Raportim i linjës",
    ResultsFeedback: "Vlerësim i rezultateve",
    NotifyNoResults: "Njoftim: pa rezultate",
    NotifyFewResults: "Njoftim: pak rezultate",
    RealTimeReport: "Raportim në kohë reale"
  },
  "Subscription.SubscriptionType": {
    NewsLetter: "Newsletter",
    Promotional: "Promocionale",
    Review: "Vlerësim",
    Abandonment: "Braktisje",
    SMS: "SMS"
  },
  "ReservationHash.HashReason": {
    QRCode: "Kod QR",
    JourneyCancellation: "Anulim i udhëtimit",
    Subscription: "Abonim"
  }
};
